<template>
  <div
    class="offcanvas offcanvas-fullscreen-sm-down offcanvas-end"
    tabindex="-1"
    id="offcanvas"
    ref="offcanvas"
    data-bs-backdrop="static"
  >
    <!-- data-bs-backdrop="static" -->
    <div class="bg-body-secondary border offcanvas-header py-2">
      {{ type === 'APPROVE'? $t('Approve & Assign'): $t('Manage Access')  }}
      <button
        type="button"
        style="font-size: small;"
        class="btn-close shadow-none text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      />
    </div>

    <div
      class="offcanvas-body"
      v-if="loading"
    >
      <placeholder-content :is-load="true" />
    </div>
    <div
      class="offcanvas-body"
      v-else-if="!hasPermission"
    >
      <access-denied/>
    </div>
    <div
      class="offcanvas-body p-0"
      v-else
    >
      <div class="container-fluid py-2 px-3">
        <div class="row g-4">
          <div class="col-md-6">
            <h6
              class="mt-2 mb-3"
            >
              <b>{{ $t('User Summary (Read-only)') }}</b>
            </h6>
            <div class="p-3 rounded border bg-light">
              <div class="d-flex align-items-start">
                <!-- Avatar -->
                <div class="me-3">
                  <div class="avatar-circle">
                    <img v-if="data.avatar" :src="data.avatar" alt="Avatar" class="img-fluid rounded-circle">
                    <i v-else class="fa-solid fa-user text-secondary fa-2x"></i>
                  </div>
                </div>
                <!-- Info -->
                <div class="user-info">
                  <div class="mb-2">
                    <label class="text-muted small mb-0">{{ $t('Full Name') }}:</label>
                    <div class="fw-bold">{{ data.fullname }}</div>
                  </div>
                  <div class="mb-2">
                    <label class="text-muted small mb-0">{{ $t('Email') }}:</label>
                    <div class="fw-bold">{{ data.email }}</div>
                  </div>
                  <div class="mb-0">
                    <label class="text-muted small mb-0">{{ $t('Telephone') }}:</label>
                    <div class="fw-bold">{{ data.telephone1 }}</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="col-md-6">
            <div class="section-title mb-3">{{ $t('Assignment & Activation') }}</div>
            <div class="p-3 rounded border">
              <div class="mb-4">
                <label class="form-label">
                  {{ $t('Assign Role') }} <span class="text-danger">*</span>
                </label>
                <select2
                  style="width: 100%;"
                  v-model="v$.form.role_id.$model"
                  :options="select2Roles.options"
                  :settings="select2Roles.setting"
                  :placeholder="$t('Select Roles') + '...'"
                />
              </div>

              <!-- Assign Branch Access -->
              <div class="mb-2">
                <label class="form-label">
                  {{ $t('Assign Branch Access') }} <span class="text-danger">*</span>
                </label>

                <!-- Toggle All Branches -->
                <div class="form-check form-switch mb-3">
                  <input
                    class="form-check-input shadow-none cursor-pointer"
                    type="checkbox"
                    id="accessAllBranches"
                    v-model="v$.form.access_all_branches.$model"
                  >
                  <label class="form-check-label cursor-pointer fw-medium" for="accessAllBranches">
                    {{ $t('Access All Branches') }}
                  </label>
                </div>

                <!-- Branch List -->
                <div class="branch-list ps-1" >
                  <div v-for="branch in checkBranchOptions" :key="branch.id" class="form-check mb-2">
                    <input
                      class="form-check-input shadow-none cursor-pointer"
                      type="checkbox"
                      :value="branch.id"
                      :id="'branch-' + branch.id"
                      v-model="v$.form.branch_ids.$model"
                      :disabled="form.access_all_branches"
                    >
                    <label class="form-check-label cursor-pointer" :for="'branch-' + branch.id">
                      {{ branch.name }}
                    </label>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-light border-top justify-content-center modal-footer py-2"
      v-if="!loading && hasPermission"
    >
      <ladda
        text="Approve"
        v-if="type === 'APPROVE'"
        :btn-class="'btn btn-primary btn-block me-2'"
        :loading="loadingSave"
        :disabled="v$.$invalid"
        @click="handleApprove"
      />
      <ladda
        text="Save"
        v-if="type === 'MANAGE'"
        :btn-class="'btn btn-primary btn-block me-2'"
        :loading="loadingSave"
        :disabled="v$.$invalid"
        @click="handleManage"
      />
      <button
        type="button"
        data-bs-dismiss="offcanvas"
        class="border-dark-subtle btn-sm btn btn-light"
      >
        {{ $t('Cancel') }}
      </button>
    </div>
  </div>
</template>

<script lang="js">
import Select2 from 'vue3-select2-component';
import AccessDenied from "@/plugins/AccessDenied.vue";
import { Users } from '@/services/endpoint/users.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue';
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation";
import Ladda from '@/plugins/Ladda.vue';
import numeral from 'numeral';
import moment from "moment";
import _ from 'lodash';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.form);
  },
  props: {
    type: {
      type: String,
      default: 'APPROVE'
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    let vm = this;
    return {
      loading: true,
      loadingSave: false,
      inValidFormAttribute: true,
      hasPermission: false,
      data: {
        avatar: '',
        fullname: '',
        email: '',
        telephone1: '',
        telephone2: ''
      },
      form: {
        name: '',
        access_all_branches: false,
        branch_ids: []
      },
      checkBranchOptions: [
      ],
      select2Roles: {
        options: [],
        setting: {
          dropdownParent: '#offcanvas',
          minimumResultsForSearch: true,
          placeholder: vm.$t('Select')+'...',
          allowClear: true
        }
      },
      isVariant: false,
    }
  },
  components: {
    Select2,
    PlaceholderContent,
    Ladda,
    AccessDenied,
  },
  methods: {
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatDigit(value) {
      return numeral(value).format("0,0.0000");
    },
    async getAcceptData() {
      await Users.getAccept(this.id).then(res => {
        this.data = res.data.data;
        this.select2Roles.options = res.data.filter.roles.map(function(role) {
          return {
            id: role.id,
            text: role.name
          }
        });
        this.checkBranchOptions = res.data.filter.branches;
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    async getUpdateData() {
      await Users.getUpdate(this.id).then(res => {
        this.select2Roles.options = res.data.filter.roles.map(function(role) {
          return {
            id: role.id,
            text: role.name
          }
        });
        this.checkBranchOptions = res.data.filter.branches;
        this.data = {
          avatar_url: res.data.data.avatar_url,
          fullname: res.data.data.fullname,
          email: res.data.data.email,
          telephone1: res.data.data.telephone1,
        };
        this.form = {
          role_id: res.data.data.role_id,
          access_all_branches: res.data.data.access_all_branch,
          branch_ids: res.data.data.branch_ids
        };
        this.hasPermission = true;
      }).catch(err => {
        if (err?.response?.status === 403) {
          this.hasPermission = false;
          this.loading = false;
        }
			  throw err;
      });
    },
    setParamsBeforeSendApprove() {
      let params = _.clone(this.form);
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    setParamsBeforeSendUpdate() {
      let params = _.clone(this.form);
      return $.each(params, (key, value) => {
        if (value === "" || value.length === 0) {
          delete params[key];
        }
      });
    },
    async handleApprove() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }
      await Users.accept(this.id, this.setParamsBeforeSendApprove()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Approve Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.errors) {
          this.oldParams = _.clone(this.form);
          this.errors = err?.response?.data?.errors;
        }
        this.$toast.warning("<B>" + this.$t('Warning') + "</B>\n" + this.$t('Approve Failed!'));
        this.loadingSave = false;
      });
    },
    async handleManage() {
      this.loadingSave = true;
      this.v$.$touch();
      if(this.v$.$invalid) {
        this.loadingSave = false;
        return;
      }

      await Users.update(this.id, this.setParamsBeforeSendUpdate()).then(res => {
        this.$parent.fetchData();
        this.$toast.success("<B>" + this.$t('Success') + "</B>\n" + this.$t('Manage Success!'));
        $(this.$refs.offcanvas).offcanvas('hide');
        this.loadingSave = false;
      }).catch(err => {
        if (err?.response?.data?.errors) {
          this.oldParams = _.clone(this.form);
          this.errors = err?.response?.data?.errors;
        }
        this.loadingSave = false;
      });
    },
  },
  async mounted() {
    $(this.$refs.offcanvas).offcanvas('show');

    $(this.$refs.offcanvas).on('shown.bs.offcanvas',async () => {
      this.loading = true;
      try {
        if (this.type === 'APPROVE') await this.getAcceptData();
        if (this.type === 'MANAGE') await this.getUpdateData();
        this.loading = false;
      } catch (err) {
      }
    });

    $(this.$refs.offcanvas).on('hidden.bs.offcanvas', () => {
      this.$parent.offcanvasFrom.open = false;
    });
  },
  computed: {
    maxUploadImg: function() {
      return this.$t('You can choose to upload a maximum of') + ' ' + this.image.maxImage + ' ' + this.$t('imaes. The size is not over') + ' ' + this.image.maxSize + ' ' + this.$t('MB.');
    },
  },
  watch: {
    // 'form.lots': {
    //   handler() {
    //     this.form.quantity = this.calculateQuantity;
    //     this.form.cost = this.calculateCost;
    //   },
    //   deep: true,
    //   immediate: true
    // }
  }
}
</script>

